import { Module } from 'framework/core';

import { TemplateAPI } from './template.api';

@Module({
  providers: [TemplateAPI],
})
export class TemplateModule {}
